import { render } from "./PaymentModal.vue?vue&type=template&id=1ca1905e"
import script from "./PaymentModal.vue?vue&type=script&lang=js"
export * from "./PaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/PaymentModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ca1905e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ca1905e', __exports__)) {
    api.reload('1ca1905e', __exports__)
  }
  
  module.hot.accept("./PaymentModal.vue?vue&type=template&id=1ca1905e", () => {
    api.rerender('1ca1905e', render)
  })

}


export default __exports__